export enum MerchantFeature {
  Coverage = "coverage",
}
